export default __webpack_public_path__ + "static/media/wattsonic.f4a46a3b.png";